// extracted by mini-css-extract-plugin
module.exports = {"availability":"Availability-module--availability--QLF84","available":"Availability-module--available--24CfU"};